import React, { PropsWithChildren } from "react";

import { ThemeProvider } from "@mui/material";

import { theme } from "@/theme/theme";

export const ThemeProviderWithPrimaryPink: React.FC<PropsWithChildren> = ({
  children,
}) => {
  return (
    <ThemeProvider
      theme={{
        ...theme,
        palette: {
          ...theme.palette,
          primary: theme.palette.pink,
        },
      }}
    >
      {children}
    </ThemeProvider>
  );
};
